import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { rootRouteRef } from './routes';
import { agentLaunchPlatformApi } from './apis';

// One page for the whole plugin: `Root` routes between the dashboard and the
// deep-linkable run and PR-group detail pages below the mount path.
// Each of those pages renders its own core-components Page/Header, so the
// framework header is off to avoid a second one. Moving to the framework/BUI
// header belongs to the MUI→BUI track.
const agentLaunchPlatformPage = PageBlueprint.make({
  params: {
    path: '/arrive-agent-launch-platform',
    routeRef: rootRouteRef,
    noHeader: true,
    loader: () => import('./components/Root').then(m => <m.Root />),
  },
});

export default createFrontendPlugin({
  pluginId: 'arrive-agent-launch-platform',
  title: 'Agent Launch Platform',
  icon: <PlayArrowIcon fontSize="inherit" />,
  info: { packageJson: () => import('../package.json') },
  // Listed in Settings → Feature Flags; it gates no UI (page and Preview card
  // show either way).
  featureFlags: [{ name: 'agent-launch-platform' }],
  routes: { root: rootRouteRef },
  extensions: [agentLaunchPlatformApi, agentLaunchPlatformPage],
});
